module.exports = __webpack_public_path__ + "static/media/compass-arrow.1642be3a.svg";